<i18n src="@/locales/modules/EventTranslate.json"></i18n>

<template>
	<div>
		<form autocomplete="off" ref="formEventConfirmation">
			<div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-2">
				<div class="vx-col w-full">
					<label for class="vs-input--label">
						{{ $t("ProfileDormitory.SchoolYear") }}
						<span class="text-danger">*</span>:
					</label>
					<vs-input
						type="number"
						v-validate="'required|max:1'"
						:placeholder="`${$t('Actions.Choose')} ${$t('ProfileDormitory.SchoolYear')}`"
						:data-vv-as="$t('SchoolYear')"
						:name="'school_year'"
						v-model="localData.school_year"
						class="w-full"
					/>
					<span class="text-danger text-sm" v-show="errors.has('school_year')">{{ errors.first("school_year") }}</span>
				</div>

				<div class="vx-col w-full">
					<label for class="vs-input--label">
						{{ $t("ProfileDormitory.Semester") }}
						<span class="text-danger">*</span>:
					</label>
					<vs-input
						type="number"
						v-validate="'required|max:1'"
						:placeholder="`${$t('Actions.Choose')} ${$t('ProfileDormitory.Semester')}`"
						:data-vv-as="$t('Semester')"
						:name="'semester'"
						v-model="localData.semester"
						class="w-full"
					/>
					<span class="text-danger text-sm" v-show="errors.has('semester')">{{ errors.first("semester") }}</span>
				</div>

				<div class="vx-col w-full">
					<label for class="vs-input--label">
						{{ $t('ProfileDormitory.Note') }}
					</label>
					<vs-input
						type="text"
						:placeholder="`${$t('Actions.Input')} ${$t('ProfileDormitory.Note')}`"
						:name="'notes'"
						v-model="localData.notes"
						class="w-full"
					/>
					<span class="text-danger text-sm" v-show="errors.has('semester')">{{ errors.first("semester") }}</span>
				</div>
			</div>
			<div class="vx-row w-full">
				<div class="vx-col w-full">
					<div class="flex flex-wrap items-center sm:justify-center">
						<vs-button class="w-full sm:w-1/3 sm:max-w-xs mt-4 font-bold" @click.prevent="confirmEvent">{{ $t("Actions.Confirm") }}</vs-button>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import moduleEvent from "@/store/event/moduleEvent";
import moduleEmployee from "@/store/employee/moduleEmployee";

export default {
    data() {
        return {
			localData: {
				school_year: null,
				semester: null,
				notes: ""
			},
            event: {}
        };
    },
    mounted() {
    },
    methods: {
		async getListEvents() {
			await this.$store.dispatch("eventManagement/fetchEvents");
		},
		async confirmEvent() {
			this.$validator
				.validateAll()
				.then(async res => {
					if (res) {
						try {
							this.$vs.loading();
							const payload = {
								...this.localData,
								employee_id: this.$store.state.AppActiveUser.id,
								event_id: this.event.id,
								extra_point: 0
							};

							await this.$store.dispatch("employeeManagement/createExtraPoint", payload);
							this.$helper.notifySuccess({
								context: this,
								options: {
									title: this.$t("EventConfirmation"),
									text: this.$t("EventConfirmationSuccessful")
								}
							});
						} catch (error) {
							this.$helper.notifyError({
								context: this,
								options: {
									title: this.$t("EventConfirmation"),
									text: this.$t("EventConfirmationFailed")
								}
							});
							this.$helper.notifyError({ context: this, error });
						} finally {
							this.$vs.loading.close();
						}
					}
				})
				.catch((error) => {
					console.log(error);
					this.$helper.notifyError({
						context: this,
						options: {
							title: this.$t("EventConfirmation"),
							text: this.$t("EventConfirmationFailed") + ": " + error
						}
					});
				});
		},
    },
	async created() {
		this.$store.registerModule("employeeManagement", moduleEmployee);
		this.$store.registerModule("eventManagement", moduleEvent);
		await this.getListEvents();
		const eventId = this.$route.params.eventId;
		if (eventId) {
			this.event = this.$store.state.eventManagement.events.find(event => event.id == eventId);
		}
	},
	beforeDestroy() {
		this.$store.unregisterModule("employeeManagement");
		this.$store.unregisterModule("eventManagement");
	}
};
</script>
